<template>

<div>

    <h1>Create new extra</h1>
    
    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createExtra">

        <ExtraFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create extra</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import axios from 'axios';
import ExtraFields from '@/components/ExtraFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'ExtraCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      extra: {},
      errors: null,
      tours: [],
      selectedAirlines : [],
      selectedTours:[]
    }
  },
  components: {
    ExtraFields,
    Errors,
  },
  methods: {
    createExtra () {
      this.$store.dispatch('setLoadStatus')
      let requestObject = {
        extra : this.extra,
        airlines: this.selectedAirlines,
        tours:this.selectedTours
      }
      fetch(this.$api + 'extras', {
        method: 'POST',
        body: JSON.stringify(requestObject),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$router.push({ name: 'extra-edit', params: { id: response.data.id }})
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    getTours()
    {
      axios.get(this.$api + 'tours')
      .then((response) => {
        this.tours = response.data.data
        // console.log(this.tours)
      });
    },
  },
  mounted()
  {
    this.getTours()
    // console.log(tours)
  }
}
</script>
